import { BASE_URL } from '@/shared/lib/const/env'

import { TProjectInfo } from '../JsonLD'

export const iPortInfo: TProjectInfo = {
	link: `https://www.iport.ru`, // NO TRAILING SLASH!
	uploadsLink: BASE_URL, // NO TRAILING SLASH!
	name: `iPort`,
	description: `Достигайте большего с совершенной техникой!`,
	logoSrc: `https://www.iport.ru/logo.svg`,
	socialLinks: [`https://vk.com/iport_apple`],
	addressLocality: `Санкт-Петербург, Россия`,
	postalCode: `190031`,
	streetAddress: `Набережная реки Фонтанки, д.109, литер А, пом. 13Н`
	//  faxNumber: `8 (812) 385-14-50`
}
